import { render, staticRenderFns } from "./UppyXHRFileUploader.vue?vue&type=template&id=93dec34c"
import script from "./UppyXHRFileUploader.vue?vue&type=script&lang=js"
export * from "./UppyXHRFileUploader.vue?vue&type=script&lang=js"
import style0 from "./UppyXHRFileUploader.vue?vue&type=style&index=0&id=93dec34c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports